<template>
  <div id="contenedor-ejecucion-default">
    <v-container fluid>
      <v-card class="mb-4" flat>
        <v-card-text>
          <titulo-tool-bar titulo="Supervisión">
            <template v-slot:opciones-derecha>
              <v-menu
                v-model="mostrarMenuExportar"
                :close-on-content-click="false"
                offset-y>
                  <template v-slot:activator="{ on: onMenu }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn icon
                      v-on="{ ...onMenu, ...onTooltip }">
                    <v-icon> mdi-file-excel </v-icon>
                      </v-btn>
                    </template>
                    <span>Exportar</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item
                  @click="mostrarExportarConceptosEstimados = !mostrarExportarConceptosEstimados"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Conceptos Estimados </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                  @click="mostrarExportarConceptosFavoritosEstimados
                  = !mostrarExportarConceptosFavoritosEstimados"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        Exportar Conceptos Favoritos Estimados
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                  @click="mostrarExportarConceptosContratos = !mostrarExportarConceptosContratos"
                  link>
                    <v-list-item-icon class="mx-2">
                      <v-icon> mdi-file-excel </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Exportar Conceptos de Contratos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :to="{ name: 'contratoEjecucionEstadisticas' }">
                  <v-icon>mdi-poll</v-icon>
                </v-btn>
              </template>
              <span>Estadisticas</span>
            </v-tooltip>
            <v-tooltip
            v-if="mixValidaScopesActions(1)"
            top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :to="{ name: 'ejecuccionConfiguracionFirmas' }">
                  <v-icon>mdi-cog-outline</v-icon>
                </v-btn>
              </template>
              <span>Configuracion</span>
            </v-tooltip>
            </template>
          </titulo-tool-bar>
          <tool-bar
            :filtros="filtros"
            :listaContratos="getContratos">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listadoContratos="getListadoDeContratos">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="mostrarExportarConceptosEstimados"
      v-model="mostrarExportarConceptosEstimados"
      width="400">
      <excel-conceptos-estimados
      v-on:cerrar="mostrarExportarConceptosEstimados = !mostrarExportarConceptosEstimados">
      </excel-conceptos-estimados>
    </v-dialog>
    <v-dialog
      v-if="mostrarExportarConceptosFavoritosEstimados"
      v-model="mostrarExportarConceptosFavoritosEstimados"
      width="500">
      <excel-conceptos-estimados-favoritos
      v-on:cerrar="mostrarExportarConceptosFavoritosEstimados
      = !mostrarExportarConceptosFavoritosEstimados">
      </excel-conceptos-estimados-favoritos>
    </v-dialog>
    <v-dialog
      v-if="mostrarExportarConceptosContratos"
      v-model="mostrarExportarConceptosContratos"
      width="400">
      <excel-conceptos-contratos
      v-on:cerrar="mostrarExportarConceptosContratos = !mostrarExportarConceptosContratos">
      </excel-conceptos-contratos>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosSupervision.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';
import ExcelConceptosEstimados from '@/components/exportar/exceles/ExcelConceptosEstimados.vue';
import ExcelConceptosEstimadosFavoritos from '@/components/exportar/exceles/ExcelConceptosEstimadosFavoritos.vue';
import ExcelConceptosContratos from '@/components/exportar/exceles/ExcelConceptosContratos.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'EjecucionDefault',
  components: {
    TituloToolBar,
    ExcelConceptosEstimados,
    ExcelConceptosEstimadosFavoritos,
    ExcelConceptosContratos,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarMenuExportar: false,
      mostrarExportarConceptosEstimados: false,
      mostrarExportarConceptosFavoritosEstimados: false,
      mostrarExportarConceptosContratos: false,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
      },
    };
  },
  mounted() {
    // Checar si hay filtros guardados.
    const filtrosGuardados = JSON.parse(this.mixGetFiltro('filtros-ejecucion'));
    if (filtrosGuardados) {
      this.filtros = JSON.parse(this.mixGetFiltro('filtros-ejecucion'));
    }
  },
  apollo: {
    contratosByEjercicio: {
      query: CONTRATOS,
      variables() {
        let ejercicio = new Date().getFullYear();
        let periodo = 1;

        if (typeof this.filtros.ejercicio === 'string') {
          const split = this.filtros.ejercicio.split('-');
          ejercicio = Number(split[0]);
          periodo = Number(split[1]);
        } else {
          ejercicio = Number(this.filtros.ejercicio);
        }
        return ({
          ejercicio,
          periodo,
        });
      },
    },
  },
  computed: {
    getContratos() {
      if (!this.contratosByEjercicio) return [];
      return this.contratosByEjercicio// Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    getListadoDeContratos() {
      if (!this.contratosByEjercicio) return [];
      return this.contratosByEjercicio
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        })
        .map((contrato) => ({
          ...contrato,
          cantidadEstimaciones: contrato.estimaciones.length,
        }))
        .map((contrato) => ({
          ...contrato,
          reportesFisicos: contrato.reportesFisicos.map((reporte) => ({
            ...reporte,
            avanceDiferencia: (reporte.avanceFisico - reporte.avanceProgramado),
          })),
        }))
        .map((contrato) => ({
          ...contrato,
          ultimoReporte: contrato.reportesFisicos.find(({ esUltimo }) => esUltimo === true) || null,
        }));
    },
  },
  watch: {
    filtros: {
      handler(filtros) {
        if (filtros.guardarFiltros) {
          this.mixGuardarFiltros('filtros-ejecucion', JSON.stringify(filtros));
        } else {
          this.mixRemoverFiltro('filtros-ejecucion');
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
</style>
